"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InPageNavigationServiceV1Imp = void 0;
const R = require("ramda");
const defaultConfigValues = {
    serviceEnabled: true,
};
class InPageNavigationServiceV1Imp {
    constructor(inputConfig) {
        this.config = Object.assign(Object.assign({}, defaultConfigValues), inputConfig);
        this.orderedAnchorList = [];
    }
    getConfig() {
        return this.config;
    }
    getOrderedAnchorsList() {
        return this.orderedAnchorList;
    }
    getActiveId() {
        return this.currentActiveId;
    }
    deleteOrderedAnchorList() {
        this.orderedAnchorList = [];
        return this.orderedAnchorList;
    }
    registerAnchor(anchor) {
        if (!R.includes(anchor.id, R.pluck('id', this.orderedAnchorList))) {
            this.orderedAnchorList = [...this.orderedAnchorList, anchor].sort(this.sortAnchors);
        }
        else {
            this.orderedAnchorList = this.orderedAnchorList
                .map((anch) => (anch.id === anchor.id ? anchor : anch))
                .sort(this.sortAnchors);
        }
    }
    setActiveId(id) {
        this.currentActiveId = id;
    }
    sortAnchors(a, b) {
        if (a.getPosition() < b.getPosition()) {
            return -1;
        }
        if (a.getPosition() > b.getPosition()) {
            return 1;
        }
        return 0;
    }
}
exports.InPageNavigationServiceV1Imp = InPageNavigationServiceV1Imp;
//# sourceMappingURL=index.js.map